<div>
  <ng-template #inputTemplate let-input>
    @for (input of input.inputs || []; track trackByChecksum($index, input)) {
      <ng-container *ngTemplateOutlet="inputTemplate; context: { $implicit: input }" />
    }

    @if (!input.inputs) {
      <div margin-bottom-small-x>
        <rti-field-mapping-form-field
          (formFieldChanged)="handleFormFieldChange($event)"
          [integrationName]="integrationName()"
          [integrationKind]="integrationKind()"
          [formConfigId]="formConfig.id"
          [formInput]="input"
          [sources]="sources()"
          [sourcesLoading]="sourcesLoading()"
        />

        <rt-divider />
      </div>
    }
  </ng-template>

  @if (isDynamic()) {
    @if (isLoading) {
      <rt-placeloader variant="item" />
    }

    <rt-box layout-vertical variant="background-light no-padding" margin-tb>
      @if (!isLoading) {
        <div padding-tb-small-x padding-lr-small layout layout-align-items-center>
          <rt-icon name="label" margin-right-small-x />

          <rt-heading variant="subheading">
            {{ formConfig.remoteName }}

            @if (formConfig.inputsCount || formConfig.inputsCount === 0) {
              <rt-badge [text]="badgeLabel()" color="counter-default" margin-left-small-x />
            }
          </rt-heading>

          <div margin-left-auto>
            @if (!isEditing()) {
              <rt-icon-button
                (click)="startEditing()"
                variant="plain"
                iconName="edit"
                shape="square"
              />
            }

            @if (isEditing()) {
              <rt-icon-button
                (click)="stopEditing()"
                variant="plain"
                iconName="clear"
                shape="square"
              />
            }
          </div>
        </div>
      }

      @if (!isLoading && isEditing()) {
        <rt-divider variant="line" />

        @if (isLoading) {
          <rt-spinner variant="small" />
        }

        @if (!isLoading && (formConfig.inputsCount || !!formConfig.errors)) {
          <div class="field-mapping-form-editable">
            @if (!!formConfig.errors) {
              <rti-error-messages-wrapper [errors]="formConfig.errors" />
            }

            @for (input of formConfig.inputs; track trackByChecksum($index, input)) {
              <ng-container *ngTemplateOutlet="inputTemplate; context: { $implicit: input }" />
            }
          </div>
        }

        @if (formConfig.inputsCount === 0) {
          <rt-infobox
            [isDismissible]="false"
            [iconName]="'info-outline'"
            type="transparent"
            padding-medium
            >{{
              'rti.field_mapping.settings.remote_template.no_mappable_fields' | translate
            }}</rt-infobox
          >
        }

        <rt-divider variant="line" />

        <div layout-horizontal layout-space-between padding class="field-mapping-form-editable">
          <div>
            <rt-button
              (click)="delete(); $event.stopPropagation()"
              variant="plain"
              class="danger-on-hover"
            >
              <rt-icon name="remove-circle" />
              <span>{{ 'rti.field_mapping.settings.remove_template' | translate }}</span>
            </rt-button>
          </div>
        </div>
      }
    </rt-box>
  }

  @if (!isDynamic()) {
    @if (isLoading) {
      <rt-spinner variant="small" />
    }

    @if (!isLoading) {
      @if (!!formConfig.errors) {
        <rti-error-messages-wrapper [errors]="formConfig.errors" />
      }

      @for (input of formConfig.inputs || []; track trackByChecksum($index, input)) {
        <ng-container *ngTemplateOutlet="inputTemplate; context: { $implicit: input }" />
      }
    }
  }
</div>
